<div class="main-report">
  <div
    class="main-slide-report-toc toc-sidebar"
    [ngClass]="isTocVisible ? 'toc-header-on' : 'toc-header-off'"
  >
    <piqet-angular-table-of-content
      [tocSections]="sectionList"
      [isCustomReport]="false"
      [isTocVisible]="isTocVisible"
      (toggleBtn)="toggleToc($event)"
      [reportAccessData]="reportAccessData"
    ></piqet-angular-table-of-content>
  </div>
  <div [ngClass]="isTocVisible ? 'toc-content-on' : 'toc-content-off'">
    <div
      class="reportSpacing main-slide-report"
      [ngStyle]="{ visibility: isLoadAllData ? 'visible' : 'hidden' }"
    >
      <!-- Cover page -->
      <!-- <div *ngIf="reportAccessData && getReportIntroduction('Cover page')">-->
      <div
        *ngIf="
          reportAccessData &&
          (reportAccessData.introduction
            | sectionFilter : reportIntroduction.coverPage) as coverPage
        "
      >
        <!-- report cover page -->
        <div>
          <!-- Piqet L ogo & Organization Logo -->
          <div
            class="logo-div d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-start align-items-md-center"
          >
            <div class="m-0 p-0 row space">
              <img [src]="piqetLogo" id="piqetLogo" alt="Piqet logo" />
            </div>
          </div>

          <!-- Project name -->
          <div class="row space main-contant mb-5">
            <div class="maintext-heading" id="projectTitleExport">
              <span>LCA of</span>
              <span class="purpleProjectName"> {{ commonData.projectName }} </span> comparing
              {{ commonData.selectedScenarioName }} packaging scenarios.
            </div>
          </div>

          <div
            class="left-align-padding d-flex flex-wrap gap-2"
            *ngIf="scenarioImages && scenarioImages?.length"
          >
            <div *ngFor="let item of scenarioImages" class="w-fit-content">
              <img *ngIf="item" [src]="item" height="100" width="100" />
            </div>
          </div>

          <div class="row space last-bottom-contant normal-heading">
            <div>PIQET project code: {{ commonData.projectCode }}</div>
            <!-- need to add dynamic date -->
            <div>
              Report generated: {{ reportData?.reportGenerateDate | date : 'yyyy-MM-dd HH:mm' }}
            </div>
            <div>Software version: PIQET {{ commonData.softwareVersion }}</div>
          </div>

          <div
            class="row space contentClass"
            *ngIf="
              reportAccessData &&
              (reportAccessData.introduction
                | sectionFilter : reportIntroduction.citation) as citation
            "
          >
            <p class="content-name">Citation</p>
            <div class="content-text">
              {{ !!commonData.authors ? commonData.authors + '.' : commonData.authors }}
              {{ commonData.projectName }} of {{ commonData.selectedScenarioName }} in
              {{ commonData.selectedDefaultLocation }}. {{ commonData.organizationName }},
              {{ commonData.organizationLocation }}.
            </div>
          </div>

          <div class="row space contentClass">
            <p class="content-name">Important disclaimer</p>
            <div class="content-text">
              Use of this ISO 14044 compliant report produced via PIQET acknowledges user
              responsibility and releases Life Cycle Strategies Pty. Ltd. from liability for any
              losses.
              <br />
              Life Cycle Strategies Pty. Ltd. and its representatives are not liable for claims,
              breaches, or damages, and users should refer to the License Agreement for details.
            </div>
          </div>
        </div>
      </div>

      <!-- figure Index list -->
      <ng-container
        *ngIf="
          reportAccessData &&
          (reportAccessData.introduction
            | sectionFilter : reportIntroduction.references) as references
        "
      >
        <piqet-angular-toc-list
          [title]="'Figures'"
          [checkWidth]="true"
          [indexList]="figureIndexList"
        >
        </piqet-angular-toc-list>

        <piqet-angular-toc-list [title]="'Tables'" [checkWidth]="true" [indexList]="tableIndexList">
        </piqet-angular-toc-list>
      </ng-container>

      <!-- Introduction page -->

      <div>
        <div class="row space mt-4" [ngClass]="{ parentTitle: introductionFlag }" id="introduction">
          <ng-container
            *ngIf="
              introductionFlag ||
              (reportAccessData &&
                (reportAccessData.introduction
                  | sectionFilter
                    : reportIntroduction.introductionIso14044Standards)) as introductionIso14044Standards
            "
          >
            <div class="row space contentClass">
              <div class="headingTitle parentNumber">#1Parent. Introduction</div>
            </div>
            <div class="row space contentClass content-text">
              <p>
                <span
                  *ngIf="
                    !!introductionData.productNames && introductionData.productNames?.length > 0
                  "
                  >{{ introductionData.organizationName }}
                  is considering the use of alternative packaging containers for
                  {{ introductionData.productNames }}.</span
                >
                The options compared in this report include {{ commonData.selectedScenarioName }}.
              </p>
              <p>
                {{ introductionData.organizationName }} has used PIQET to undertake a life cycle
                assessment (LCA) of these packaging options for both internal information and
                potentially for external communication .
              </p>
              <p>
                The framework and principles of LCA are described in the international standard ISO
                14040 (International Organization for Standardization 2006). The general structure
                of the LCA framework is shown in
                <a (click)="scrollToElement(0 + 'figureIndex')">Figure 1</a>. This figure
                demonstrates how each stage of the LCA interacts with other stages. The specific
                requirements for LCA are defined by ISO 14044 (International Organization for
                Standardization, 2006), guide this report, which aims to comply with ISO 14044 in
                both its underlying methodology and content.
              </p>
            </div>
            <div class="row space contentClass chartDesign">
              <span
                ><img src="./assets/images/PIQET LCA Framework 1.svg" width="650" height="500"
              /></span>
              <p class="uniqFigureSeq content-figure">
                Figure #1: Framework for life cycle assessment
              </p>
            </div>
          </ng-container>

          <div
            class="contentClass row space"
            id="criticalReview"
            *ngIf="
              reportAccessData &&
              (reportAccessData.introduction
                | sectionFilter
                  : reportIntroduction.criticalReviewConsiderations) as criticalReviewConsiderations
            "
          >
            <p class="content-name childNumber">#1Child Critical review considerations</p>
            <ng-container *ngIf="commonData.authors; else noReviewer">
              <div class="content-text">
                <div class="">
                  <p>
                    In line with ISO 14044 recommendation, an independent critical review of the
                    study was conducted. The critical review is a process
                    <em
                      >'intended to ensure consistency between a life cycle assessment and the
                      principles and requirements of the International Standards on life cycle
                      assessment'</em
                    >.
                  </p>

                  <p>
                    A critical review can be undertaken either by an external expert, which is the
                    case here, or by a panel of interested parties. The latter is the preferred
                    option when the LCA is used to support comparative assertions made to the public
                    however, this is a suggestion not a requirement. Given the scope of this
                    analysis, a critical review by a single independent LCA expert was deemed
                    sufficient.
                  </p>

                  <p>A critical review was undertaken by {{ commonData.authors }}.</p>

                  <p>The critical review statement is attached in Appendix A.</p>
                </div>
              </div>
            </ng-container>
            <ng-template #noReviewer>
              <div class="context-text">
                This being said, the report was not externally peer-reviewed according to and
                against ISO 14044.
              </div>
            </ng-template>
          </div>
        </div>
        <div
          class="row space contentClass"
          [ngClass]="{ parentTitle: execulativeSummaryFlag }"
          id="execulativeSummary"
          *ngIf="execulativeSummaryFlag"
        >
          <div class="headingTitle parentNumber">#1Parent. Executive summary</div>
          <div
            class="contentMiniClass"
            id="projectSummary"
            *ngIf="
              reportAccessData &&
              (reportAccessData.executiveSummary
                | sectionFilter : reportExecutiveSummary.projectSummary) as projectSummary
            "
          >
            <p class="content-name childNumber">#1Child Project details</p>
            <div class="contentMiniClass">
              <p class="content-name-subtitle uniqTableSeq">
                Table #1 :
                {{ reportResource.lblSummaryProject }}
              </p>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>PIQET project code</td>
                      <td>{{ projectDetails?.projectCode }}</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Name</td>
                      <td>{{ projectDetails?.projectName }}</td>
                    </tr>
                    <tr>
                      <td>Description</td>
                      <td>{{ projectDetails?.projectDescription }}</td>
                    </tr>
                    <tr>
                      <td>Share with</td>
                      <td>{{ projectDetails?.shareWith }}</td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td>{{ projectDetails?.status }}</td>
                    </tr>
                    <tr *ngIf="!projectDetails.isTurnOffCost">
                      <td>Currency</td>
                      <td>{{ projectDetails?.currency }}</td>
                    </tr>
                    <tr>
                      <td>Default country</td>
                      <td>{{ projectDetails?.defaultCountry }}</td>
                    </tr>
                    <tr>
                      <td>Other countries</td>
                      <td>{{ projectDetails?.otherCountries }}</td>
                    </tr>
                    <tr>
                      <td>Basis for comparison</td>
                      <td>{{ projectDetails?.basisforComparision }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="contentMiniClass">
              <p class="content-name-subtitle uniqTableSeq">
                Table #1
                {{ reportResource.lblSummaryScenarios }}
              </p>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>Package product system</td>
                      <td>Package</td>
                      <td>Product</td>
                      <td>Product quantity</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let scenario of reportData?.inventoryAnalysis.propackscenarioList">
                      <td>{{ scenario.propackScenarioname }}</td>
                      <td>{{ scenario.package }}</td>
                      <td>{{ scenario.productSector }}</td>
                      <td>{{ scenario.productQuantity }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            class="contentMiniClass"
            id="scenarioComparison"
            *ngIf="
              reportAccessData &&
              (reportAccessData.executiveSummary
                | sectionFilter : reportExecutiveSummary.spiderChartSummary) as spiderChartSummary
            "
          >
            <p class="content-name childNumber">#1Child Scenario comparison</p>
            <div class="content-name-subtitle">At a glance comparison</div>
            <div class="para">
              <p>
                The following chart compares the relative impact of selected scenarios on equal
                weighted indicators.
              </p>
              <p>
                Note: Spider diagram below shows relative impacts of scenarios being compared;
                closer to the centre, lesser is the environmental impact.
              </p>
            </div>
            <div class="uniqFigurescroll">
              <ng-container *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0">
                <div class="contentMiniClass chartDesign">
                  <div class="chart-div d-flex justify-content-center align-items-center">
                    <div class="w-100 text-center" style="height: 500px">
                      <piqet-angular-radar-chart
                        [spiderChartData]="componentItemsArray"
                        [chartOpacity]="chartOpacity"
                      ></piqet-angular-radar-chart>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div
                class="contentMiniClass"
                *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0"
              >
                <p class="content-figure uniqFigureSeq spiderChartPadding">
                  Figure #1: The proportional difference in impact between each package
                </p>
              </div>
            </div>
          </div>
          <div
            class="contentMiniClass"
            id="resultSummary"
            *ngIf="
              spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0 &&
              reportAccessData &&
              (reportAccessData.executiveSummary
                | sectionFilter : reportExecutiveSummary.resultSummaryTable) as resultSummaryTable
            "
          >
            <p class="content-name childNumber">#1Child Results summary table</p>
            <p class="content-name-subtitle uniqTableSeq">
              Table #1: Life cycle impacts – Per package
            </p>
            <div class="row table-div">
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>{{ reportResource.lblImageCategory }}</td>
                      <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
                        {{ item?.scenarioname }}
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      *ngFor="
                        let p of getRange(
                          spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';')
                            ?.length
                        )
                      "
                    >
                      <td>
                        <div class="rowImageAndValueSet">
                          <div><img width="40" height="40" [src]="imagelist[p]" /></div>
                          <br />
                          <div class="rowTextCss">
                            <span style="padding-right: 15px; display: block">{{
                              indicatornamelist[p]
                            }}</span>
                            <span class="verticalTableHeader" style="margin-top: 1px !important">{{
                              indicatorunitnamelist[p]
                            }}</span>
                          </div>
                        </div>
                      </td>
                      <td *ngFor="let data of spiderChartItemsData.scenarioListForAnnumImpact">
                        {{ data.totals.split(';')[p] | decimalFormatPipe }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            class="contentMiniClass"
            id="comparisonBenchmarks"
            *ngIf="
              spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0 &&
              reportAccessData &&
              (reportAccessData.executiveSummary
                | sectionFilter
                  : reportExecutiveSummary.comparisonToBenchmark) as comparisonToBenchmark
            "
          >
            <p class="content-name childNumber">#1Child Comparison to benchmark</p>
            <div class="contentMiniClass">
              <p class="content-name-subtitle uniqTableSeq">
                Table #1: Life cycle impacts relative to reference scenario - Per package
              </p>
              <div class="row">
                <div class="col12">
                  <p class="content-page-details">{{ reportResource.lblLowerImpact }}</p>
                  <p class="content-page-details">{{ reportResource.lblHigherImpact }}</p>
                </div>
              </div>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>{{ reportResource.lblCategory }}</td>
                      <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
                        {{ item?.scenarioname }}
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      *ngFor="
                        let p of getRange(
                          spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';')
                            ?.length
                        )
                      "
                    >
                      <td>
                        <span style="padding-right: 15px">{{ indicatornamelist[p] }}</span>
                        <span class="verticalTableHeader" style="margin-top: 1px !important"
                          >({{ indicatorunitnamelist[p] }})</span
                        >
                      </td>
                      <td *ngFor="let data of spiderChartItemsData.scenarioListForAnnumImpact">
                        {{ data.savingPercentage.split(';')[p] | decimalFormatPipe }}%
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            class="contentMiniClass"
            id="annualized"
            *ngIf="
              spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0 &&
              reportAccessData &&
              (reportAccessData.executiveSummary
                | sectionFilter : reportExecutiveSummary.annualizedResult) as annualizedResult
            "
          >
            <p class="content-name childNumber">#1Child Annualized results</p>
            <div class="contentMiniClass">
              <p class="content-name-subtitle uniqTableSeq">
                Table #1: Life cycle impacts relative to reference scenario - Per annum
              </p>
              <!-- this div not is piqet 4  -->
              <div class="row">
                <div class="col12">
                  <p class="content-page-details">{{ reportResource.lblLowerImpact }}</p>
                  <p class="content-page-details">{{ reportResource.lblHigherImpact }}</p>
                </div>
              </div>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>{{ reportResource.lblCategory }} (Indicator)</td>
                      <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
                        {{ item?.scenarioname }}
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      *ngFor="
                        let p of spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(
                          ';'
                        );
                        let i = index
                      "
                    >
                      <td>
                        <span class="verticalTableHeader" style="margin-top: 1px !important"
                          >{{ p }} ({{ indicatorunitnamelist[i] }})</span
                        >
                      </td>
                      <td
                        *ngFor="
                          let item of spiderChartItemsData?.scenarioListForAnnumImpact;
                          let k = index
                        "
                      >
                        {{
                          getMulti(
                            spiderChartItemsData.scenarioListForAnnumImpact[k].totals.split(';')[i],
                            spiderChartItemsData.scenarioListForAnnumImpact[k].numberofUnits
                          ) | decimalFormatPipe
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row space contentClass"
          [ngClass]="{ parentTitle: goalAndScopeFlag }"
          id="goalAndScope"
          *ngIf="goalAndScopeFlag"
        >
          <div class="headingTitle parentNumber">#1Parent. Goal and scope</div>
          <div
            class="contentMiniClass"
            id="goal"
            *ngIf="
              reportAccessData &&
              (reportAccessData.goalAndScope
                | sectionFilter : reportGoalAndScope.goalAndScope) as goalAndScope
            "
          >
            <p class="content-name childNumber">#1Child Goal</p>
            <div class="content-text">
              {{
                !!goalAndScopeData?.goal && goalAndScopeData?.goal != ''
                  ? goalAndScopeData?.goal
                  : reportResource.lblNoTextAdded
              }}
            </div>
          </div>
          <div
            class="contentMiniClass"
            id="functionalUnit"
            *ngIf="
              reportAccessData &&
              (reportAccessData.goalAndScope
                | sectionFilter : reportGoalAndScope.functionalUnit) as functionalUnit
            "
          >
            <p class="content-name childNumber">#1Child Functional unit</p>
            <div class="content-text">
              The functional unit (FU) is the basis for comparison of alternatives in LCA. It
              describes the service delivered by the processes being studied. In this LCA the
              function of the package is safe and functional containment of the product from the
              point of production to the point of consumption. Accordingly, the FU for this study is
              <span *ngIf="goalAndScopeData?.functionalUnitId == 1"
                >"One retail package of product delivered to the consumer."</span
              >
              <span *ngIf="goalAndScopeData?.functionalUnitId == 2"
                >"A kilogram of product delivered to the consumer."</span
              >
              <span *ngIf="goalAndScopeData?.functionalUnitId == 3"
                >"One retail package volume equivalent delivered to the consumer."</span
              >
            </div>
          </div>
          <div>
            <div
              class="contentMiniClass"
              id="systemBoundaries"
              *ngIf="
                reportAccessData &&
                (reportAccessData.goalAndScope
                  | sectionFilter : reportGoalAndScope.systemBoundary) as systemBoundary
              "
            >
              <p class="content-name childNumber">#1Child System boundaries</p>

              <div class="content-text">
                The system boundary describes the process steps included in the LCA. Typically, the
                system boundary should include processes or operations that are substantially
                affected by demand for the product (<a (click)="scrollToElement(1 + 'figureIndex')"
                  >Figure 2</a
                >).
              </div>
              <div class="content-text">
                This includes extraction and production processes and any additional activities
                required to make each option functionally equivalent. It also includes the effects
                of co-products produced along the supply chain. It may include capital and service
                inputs, depending on the scale of their contribution. (Figure 2. - 'System
                boundary').
              </div>
              <div class="mt-5 text-center chartDesign">
                <span
                  ><img
                    class="img-fluid"
                    [src]="goalAndScopeData?.systemBoundaryImage"
                    width="650"
                    height="800"
                /></span>
              </div>
              <p class="uniqFigureSeq pt-3 content-figure">
                Figure #1: System boundary of the product systems that were analyzed
              </p>
              <br />
              <div class="content-text">
                The system boundary may exclude elements that fall below the cut-off threshold. The
                cut-off threshold used for this study was less than
                {{ goalAndScopeData?.cutOffPercentage }} of any impact category included in the LCA.
                The boundary can also exclude processes that are common to all options assessed and
                therefore do not affect the choice of option.
              </div>
              <br />
              <div class="content-text" *ngIf="!!goalAndScopeData.systemBoundaryJustification">
                The {{ commonData?.projectName }} system boundary includes
                {{ goalAndScopeData.systemBoundaryJustification }}
              </div>
            </div>
          </div>
          <div
            class="contentMiniClass"
            id="includedProcess"
            *ngIf="
              reportAccessData &&
              (reportAccessData.goalAndScope
                | sectionFilter : reportGoalAndScope.includedProcesses) as includedProcesses
            "
          >
            <p class="content-name childNumber">#1Child Included processes</p>
            <div class="content-text">
              <ng-container *ngIf="isIncludedProcessExist">
                <p>The included processes are:</p>
                <div class="mb-3">
                  <ul>
                    <ng-container *ngFor="let item of includeProcessHideShowDetailModel">
                      <li *ngIf="item.selected && item.flag">
                        <span> {{ item.name }}:</span> {{ item.description }}
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </ng-container>
              <ng-container *ngIf="isIncludedPackagingExist">
                <p>The included packaging system are:</p>
                <div>
                  <ul>
                    <ng-container *ngFor="let item of includeProcessHideShowDetailModel">
                      <li *ngIf="item.selected && !item.flag">
                        <span> {{ item.name }}:</span> {{ item.description }}
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </ng-container>
            </div>
          </div>
          <div
            class="contentMiniClass"
            id="excludedProcess"
            *ngIf="
              reportAccessData &&
              (reportAccessData.goalAndScope
                | sectionFilter : reportGoalAndScope.excludedProcesses) as excludedProcesses
            "
          >
            <p class="content-name childNumber">#1Child Excluded processes</p>
            <div class="content-text">
              <p>
                As part of this study, the following processes and stages are considered excluded or
                out of the scope of this study.
              </p>
              <ng-container *ngIf="isExcludedProcessExist">
                <p>The excluded processes are:</p>
                <div>
                  <ul>
                    <ng-container *ngFor="let item of includeProcessHideShowDetailModel">
                      <li *ngIf="!item.selected && item.flag">
                        <span> {{ item.name }}: </span> {{ item.description }}
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </ng-container>
              <ng-container *ngIf="isExcludedPackagingExist">
                <p>The excluded packaging system are:</p>
                <div>
                  <ul>
                    <ng-container *ngFor="let item of includeProcessHideShowDetailModel">
                      <li *ngIf="!item.selected && !item.flag">
                        <span> {{ item.name }}: </span> {{ item.description }}
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </ng-container>
              <p *ngIf="!!goalAndScopeData?.excludedProcessesJustification">
                The justification for the excluded processes is:
                {{ goalAndScopeData?.excludedProcessesJustification }}
              </p>
            </div>
          </div>
          <div
            class="contentMiniClass"
            id="multiFunctionality"
            *ngIf="
              reportAccessData &&
              (reportAccessData.goalAndScope
                | sectionFilter : reportGoalAndScope.multiFunctionality) as multiFunctionality
            "
          >
            <p class="content-name childNumber">#1Child Multi-functionality</p>
            <div class="content-text">
              Multi-functionality occurs when a single process, or group of processes, produces more
              than one usable output, or 'co-product'. ISO (International Organization for
              Standardization 2006) defines a product as 'any good or service, with value for the
              user'. This is distinct from a 'waste', which ISO defines as 'substances or objects
              which the holder intends or is required to dispose of', and therefore has no value to
              the user. A co-product is defined as 'any of two or more products coming from the same
              unit process or product system'.
            </div>
            <!-- <br> -->
            <!-- <div class="content-text">In PIQET, the background database is built on an attributional basis along
                                    the lines of the ecoinvent cut-off model which includes a range of allocation methods such as
                                    economic and physical allocation where appropriate.</div> -->
            <br />
            <div class="content-text">
              In this LCA the main allocation issue relates to the allocation of the recycling
              credit between the product system which generates the packaging to be recycled and the
              product system which utilizes the recycled material as secondary material input.
            </div>
            <!-- <br>
                                <div class="content-text">PIQET uses the Circular Footprint Formula approach as defined by the PEF
                                    to address EoL allocation questions.</div> -->
            <br />
            <div class="content-text">
              In PIQET, by default A=0.5, meaning that the benefits of recycling are shared equally
              between the two systems. PIQET also offers the option to select a list of PEF
              compliant A factors or custom A factors.
            </div>
            <br />
            <div class="content-text">
              the PEF defines the A factor which allocates burdens and credits between these two
              life cycles and aims to reflect market realities. The A factor values range between
              0.2 and 0.8 to always capture both aspects of recycling (recycled content and
              recyclability at end-of-life(EoL)).
            </div>
            <ul>
              <li>
                <div class="content-text">
                  A=0.2 - Low offer of recyclable materials and high demand: the formula focus on
                  recyclability at end-of-life.
                </div>
              </li>
              <li>
                <div class="content-text">
                  A=0.8 - High offer of recyclable materials and low demand: the formula focus on
                  recycled content.
                </div>
              </li>
              <li>
                <div class="content-text">
                  A=0.5 - Equilibrium between offer and demand: the formula focuses both on
                  recyclability at EoL and recycled content.
                </div>
              </li>
            </ul>
            <div class="content-text">
              A=0.5 is also recommended for use for all materials for which no A value is available
              or in scenarios where there is high uncertainty or variability.
            </div>

            <ng-container *ngIf="materialList && materialList?.length > 0">
              <div
                class="content-text"
                *ngIf="
                  !!reportData?.goalAndScope?.multiFunctionalDescription &&
                    reportData?.goalAndScope?.multiFunctionalDescription != '';
                  else multiFunctionalDescriptionBlock
                "
              >
                The author's A factor selection is defined and detailed in
                <a (click)="scrollToElement(allcationFactorTableId - 1 + 'tableIndex')"
                  >Table {{ allcationFactorTableId }}</a
                >, and is justified by {{ reportData?.goalAndScope?.multiFunctionalDescription }}.
              </div>
              <ng-template #multiFunctionalDescriptionBlock>
                <div class="content-text">
                  The author's A factor selection is defined and detailed in
                  <a (click)="scrollToElement(allcationFactorTableId - 1 + 'tableIndex')"
                    >Table {{ allcationFactorTableId }}</a
                  >.
                </div>
              </ng-template>
              <br />
              <div class="contentMiniClass">
                <p class="content-name-subtitle uniqTableSeq">
                  Table #1: Recycling allocation factors
                </p>
                <div class="table-content">
                  <table class="table">
                    <thead>
                      <tr>
                        <td>Material</td>
                        <td>A Factor method</td>
                        <td>A Factor value</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of materialList">
                        <td>{{ item.name }}</td>
                        <td>{{ item.aFactorMethod }}</td>
                        <td>{{ item.aFactorValue }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-container>
          </div>
          <div
            class="contentMiniClass"
            id="impactAssessmentCategory"
            *ngIf="
              reportAccessData &&
              (reportAccessData.goalAndScope
                | sectionFilter : reportGoalAndScope.impactCategories) as impactCategories
            "
          >
            <p class="content-name childNumber">#1Child Impact assessment categories</p>
            <div class="content-text">
              The impact assessment stage relates the inventory flows to the indicator chosen for
              the LCA. This was done by classifying which flows relate to which impact category and
              selecting a characterization model that quantify the relationship of each inventory
              type to the indicator in question. The calculation of the category indicator results
              is the summation of all inventory flows multiplied by their relevant characterization
              factors, the models for which are detailed in
              <a (click)="scrollToElement(categoryDefTableId - 1 + 'tableIndex')"
                >Table {{ categoryDefTableId }}</a
              >.
            </div>
            <div>
              <piqet-angular-report-categories-definition
                [indicatorList]="commonData?.indicatorList"
                [isCheckISO]="true"
              ></piqet-angular-report-categories-definition>
            </div>

            <div
              *ngIf="!!goalAndScopeData?.impactCategoryJustification"
              class="contentMiniClass"
              id="impactAssessmentCategorytext"
            >
              <div class="content-text">
                {{ goalAndScopeData?.impactCategoryJustification }}
              </div>
            </div>
          </div>
          <ng-container
            *ngIf="
              reportAccessData &&
              (reportAccessData.goalAndScope
                | sectionFilter : reportGoalAndScope.dataQualityFramework) as dataQualityFramework
            "
          >
            <div class="contentMiniClass" id="dataQualityAssessment">
              <p class="content-name childNumber">#1Child Data quality requirements</p>
              <div class="content-text">
                Data quality was assessed for all input data and ranked in terms of its fitness for
                purpose. The key data quality criteria for the study are:
              </div>
              <br />
              <div class="content-text content-text-goal">
                <ul>
                  <li>
                    <p>Completeness (measured vs estimated data)</p>
                  </li>
                  <li>
                    <p>Time-related coverage (age of data)</p>
                  </li>
                  <li>
                    <p>Geographical coverage (geographical area from which data was collected)</p>
                  </li>
                  <li>
                    <p>Technology coverage (specific technology vs technology mix)</p>
                  </li>
                </ul>
              </div>
              <br />
              <div class="content-text">
                Data quality results are averaged across all four indicators. The final data quality
                rate ranges between 1 (Poor) and 4 (Very good). The data quality framework was
                adapted from the ecoinvent pedigree matrix. The data quality assessment results are
                presented in <a (click)="scrollToElement('dataQualityAssessment5')">Section 5.4</a>.
              </div>
            </div>
            <div class="contentMiniClass">
              <p class="content-name-subtitle uniqTableSeq">
                Table #1: Data quality assessment framework
              </p>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td></td>
                      <td>Poor (1)</td>
                      <td>Fair (2)</td>
                      <td>Good (3)</td>
                      <td>Very good (4)</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Reliability</td>
                      <td>Non-qualified estimate</td>
                      <td>Qualified estimate</td>
                      <td>Modelled data</td>
                      <td>Primary measured data</td>
                    </tr>
                    <tr>
                      <td>Time-related coverage</td>
                      <td>From past production >10 years old</td>
                      <td>From past production >5 years old and less than 10 years old</td>
                      <td>From past production >2 years old and less than 5 years old</td>
                      <td>From current production data < 2 years old</td>
                    </tr>
                    <tr>
                      <td>Geographical coverage</td>
                      <td>From distinctly dissimilar region</td>
                      <td>From global average</td>
                      <td>From similar region</td>
                      <td>From region of interest</td>
                    </tr>
                    <tr>
                      <td>Technology coverage</td>
                      <td>From old or dissimilar technology</td>
                      <td>Generic technology average</td>
                      <td>From Technology specific to region</td>
                      <td>From actual technology used</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
          <!-- <div class="contentMiniClass" id="otherAssumption">
                            <p class="content-name">2.7 Other assumptions</p>
                            <div *ngIf="!!goalAndScope?.otherAssumptions && goalAndScope?.otherAssumptions != '' else otherAssumption"
                                class="content-text">
                                {{goalAndScope?.otherAssumptions}}
                            </div>
                            <ng-template #otherAssumption>
                                <div>
                                    {{reportResource.lblNoTextAdded}}
                                </div>
                            </ng-template>
                        </div> -->
        </div>
        <div
          class="row space contentClass"
          id="inventoryParent"
          *ngIf="inventoryFlag"
          [ngClass]="{ parentTitle: inventoryFlag }"
        >
          <div class="headingTitle parentNumber">#1Parent. Inventory</div>
          <ng-container
            *ngIf="
              reportAccessData &&
              (reportAccessData.inventory
                | sectionFilter : reportInventory.inventoryAnalysis) as inventoryAnalysis
            "
            id="inventoryAnalysis"
          >
            <p class="content-name childNumber" id="">#1Child Inventory analysis</p>
            <div class="content-text">
              <p>
                Inventory analysis is the stage of the LCA where the system being studied is broken
                up into unit processes. Unit processes fall within the foreground or background of
                the model, as defined below.
              </p>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              reportAccessData &&
              (reportAccessData.inventory
                | sectionFilter : reportInventory.foregroundDataEnter) as foregroundDataEnter
            "
          >
            <div class="contentMiniClass" id="foregroundData">
              <p class="content-name childNumber">#1Child Foreground data</p>
              <div class="content-text">
                Foreground data used throughout this analysis are detailed in the following tables:
              </div>
              <div class="content-text">
                <p>All foreground data was entered by {{ introductionData?.organizationName }}.</p>
              </div>
            </div>
            <div class="contentMiniClass">
              <ng-container
                *ngFor="let impactItems of reportData.scenarioDetailItemList; let k = index"
              >
                <piqet-angular-report-scenario-detail
                  [impactItems]="impactItems"
                  [isCheckISO]="true"
                  [processIncluded]="impactItems.projectProcessList"
                  [scenarioDataList]="reportData.scenarioDetailItemList[k]"
                ></piqet-angular-report-scenario-detail>
              </ng-container>
            </div>
          </ng-container>
          <div
            class="contentMiniClass"
            id="otherAssumption"
            *ngIf="
              reportAccessData &&
              (reportAccessData.inventory
                | sectionFilter : reportInventory.otherAssumptions) as otherAssumptions
            "
          >
            <p class="content-name childNumber">#1Child Other assumptions</p>
            <div
              *ngIf="
                !!goalAndScopeData?.otherAssumptions && goalAndScopeData?.otherAssumptions != '';
                else otherAssumption
              "
              class="content-text"
            >
              <span
                class="common-font"
                [innerHTML]="formatText(goalAndScopeData?.otherAssumptions)"
              ></span>
            </div>
            <ng-template #otherAssumption>
              <div>
                {{ reportResource.lblNoTextAdded }}
              </div>
            </ng-template>
          </div>
          <ng-container
            *ngIf="
              reportAccessData &&
              (reportAccessData.inventory
                | sectionFilter : reportInventory.backGroundData) as backGroundData
            "
          >
            <div class="contentMiniClass" id="backgroundData">
              <p class="content-name childNumber">#1Child Background data</p>
              <div class="content-text">
                The model background includes unit processes for which data is typically sourced
                from pre-existing databases. Refer to the PIQET data manual.
              </div>
            </div>
            <div class="contentMiniClass">
              <ng-container *ngFor="let item of reportData.dataSourceDetailItemList">
                <piqet-angular-report-data-source-etails
                  [isCheckISO]="true"
                  [processIncluded]="reportData?.goalAndScope?.includeProcessHideShowViewModel"
                  [impactItems]="item"
                ></piqet-angular-report-data-source-etails>
              </ng-container>
            </div>
          </ng-container>
        </div>
        <div
          class="row space contentClass"
          [ngClass]="{ parentTitle: impactAssessmentResultsFlag }"
          id="impactAssessmentResults"
          *ngIf="impactAssessmentResultsFlag"
        >
          <div class="headingTitle parentNumber">#1Parent. Impact assessment results</div>
          <ng-container
            *ngIf="
              reportAccessData &&
              (reportAccessData.impactAssessmentResults
                | sectionFilter
                  : reportImpactAssessmentResult.resultsCharacterization) as resultsCharacterization
            "
          >
            <div class="contentMiniClass" id="resultSummaryCharacterization">
              <p class="content-name childNumber">#1Child Results summary characterization</p>
            </div>
            <div class="content-text contentMiniClass">
              <p>
                Impact assessment takes the total inventory results and groups them into the
                indicators of interest. The total contribution was calculated for each indicator, a
                step referred to as the characterization.
              </p>
              <p>
                The results, given in
                <a (click)="scrollToElement(equevalancyTableId - 1 + 'tableIndex')"
                  >Table {{ equevalancyTableId }}</a
                >
                , are presented in equivalents units for each indicator, such as kg
                CO<sub>2</sub>eq.
                <span *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0"
                  ><a (click)="scrollToElement(2 + 'tableIndex')"
                    >Table {{ lifeCycleImpactTableId }}</a
                  >
                  highlights the proportional deference to {{ commonData?.baseScenarioName }}.</span
                >
              </p>
              <p *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0">
                Comparisons of these results for each package are shown in
                <a (click)="scrollToElement(2 + 'figureIndex')">Figure 3</a>.
              </p>
            </div>
            <div
              class="contentMiniClass"
              *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0"
            >
              <p class="content-name-subtitle uniqTableSeq">
                Table #1: {{ reportResource.lblLifeCycleImpact }} -
                {{ spiderChartItemsData?.functionalUnitName | lowercase }}
              </p>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>{{ reportResource.lblImageCategory }}</td>
                      <ng-container
                        *ngIf="
                          spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0;
                          else noDataScenarioListForAnnumImpactHeader
                        "
                      >
                        <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
                          {{ item?.scenarioname }}
                        </td>
                      </ng-container>
                      <ng-template #noDataScenarioListForAnnumImpactHeader>
                        <td *ngFor="let item of reportData?.scenarioDetailItemList">
                          {{ item?.scenarioName }}
                        </td>
                      </ng-template>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let p of getRange(
                          spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';')
                            ?.length
                        )
                      "
                    >
                      <td>
                        <div class="d-flex">
                          <div class="imageISO">
                            <img width="40" height="40" [src]="imagelist[p]" />
                          </div>
                          <br />
                          <div class="ms-3">
                            <span style="padding-right: 15px; display: block">{{
                              indicatornamelist[p]
                            }}</span>
                            <span class="verticalTableHeader" style="margin-top: 1px !important">{{
                              indicatorunitnamelist[p]
                            }}</span>
                          </div>
                        </div>
                      </td>
                      <td *ngFor="let data of spiderChartItemsData.scenarioListForAnnumImpact">
                        {{ data.totals.split(';')[p] | decimalFormatPipe }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="figureReferenceText">
              The proportional difference in impact between each package are shown in Figure 3.
            </div>
            <div class="uniqFigurescroll">
              <ng-container *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0">
                <div class="contentMiniClass chartDesign">
                  <div class="chart-div d-flex justify-content-center align-items-center">
                    <div class="w-100 text-center" style="height: 500px">
                      <piqet-angular-radar-chart
                        [spiderChartData]="componentItemsArray"
                        [chartOpacity]="chartOpacity"
                      ></piqet-angular-radar-chart>
                    </div>
                  </div>
                </div>
              </ng-container>
              <div
                class="contentMiniClass"
                *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0"
              >
                <p class="content-figure uniqFigureSeq spiderChartPadding">
                  Figure #1: The proportional difference in impact between each package
                </p>
              </div>
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              reportAccessData &&
              (reportAccessData.impactAssessmentResults
                | sectionFilter
                  : reportImpactAssessmentResult.resultSummaryNormalized) as resultSummaryNormalized
            "
          >
            <div class="contentMiniClass" id="resultSummaryNormalized">
              <p class="content-name childNumber">#1Child Results summary normalized</p>
              <div class="content-text contentMiniClass">
                <p>
                  To try and understand the relative importance of the different impact categories
                  LCA results can be normalized against total annual impacts per person in the
                  world.
                </p>
                <p *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0">
                  The normalized impacts of the
                  {{ spiderChartItemsData?.scenarioList?.length }} scenarios are shown in
                  <a (click)="scrollToElement(3 + 'figureIndex')">figure 4</a>. This provides
                  context as to how much each scenario contributes to the total global impact in
                  each impact category, and thus how relevant each impact category is when looking
                  at this specific system.
                </p>
              </div>
            </div>
            <div
              class="contentMiniClass"
              *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0"
            >
              <p class="content-name-subtitle uniqTableSeq">
                Table #1: Normalized impacts - per package
              </p>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>{{ reportResource.lblImageCategory }}</td>
                      <ng-container
                        *ngIf="
                          spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0;
                          else noDataScenarioListForAnnumImpactHeadersecond
                        "
                      >
                        <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
                          {{ item?.scenarioname }}
                        </td>
                      </ng-container>
                      <ng-template #noDataScenarioListForAnnumImpactHeadersecond>
                        <td *ngFor="let item of reportData?.scenarioDetailItemList">
                          {{ item?.scenarioName }}
                        </td>
                      </ng-template>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let p of getRange(
                          spiderChartItemsData?.scenarioList[0]?.indicators.split(';')?.length
                        )
                      "
                    >
                      <td>
                        <div class="d-flex">
                          <div><img width="40" height="40" [src]="imagelist[p]" /></div>
                          <br />
                          <div class="ms-3">
                            <span style="padding-right: 15px; display: block">{{
                              indicatornamelist[p]
                            }}</span>
                            <!-- <span class="verticalTableHeader"
                                                                style="margin-top: 1px !important">{{indicatorunitnamelist[p]
                                                                }}</span> -->
                          </div>
                        </div>
                      </td>
                      <td *ngFor="let data of spiderChartItemsData.scenarioList">
                        {{ data.normalizedValue.split(';')[p] | decimalFormatPipe }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <ng-container *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0">
              <div class="contentMiniClass chartDesign">
                <p class="content-figure uniqFigureSeq">
                  Normalized impacts - per package as a fraction of entire global impacts in the
                  year {{ staticDate | date : 'yyyy' }} is shown in figure #1
                </p>
              </div>
              <div class="contentMiniClass chartDesign">
                <piqet-angular-bar-chart
                  [chartData]="componentItemsArrayISOreport"
                  [chartOpacity]="chartOpacity"
                  [indicatorsName]="indicatorsName"
                  [chartType]="generatedChartType"
                  [isChartNormalized]="true"
                  [isShowValue]="true"
                ></piqet-angular-bar-chart>
              </div>
              <div class="contentMiniClass">
                <p class="content-figure uniqFigureSeq">
                  Figure #1: Normalized impacts - per package as a fraction of entire global impacts
                  in the year {{ staticDate }}
                </p>
              </div>
            </ng-container>
          </ng-container>
          <ng-container
            *ngIf="
              reportAccessData &&
              (reportAccessData.impactAssessmentResults
                | sectionFilter
                  : reportImpactAssessmentResult.resultAnnulizedEquivalence) as resultAnnulizedEquivalence
            "
          >
            <div class="contentMiniClass" id="resultAnnualized">
              <p class="content-name childNumber">
                #1Child Results annualized with equivalence values
              </p>
              <div class="content-text contentMiniClass">
                <p>
                  Furthermore, annualized equivalence values are employed to convey the impact of an
                  indicator when utilized in a practical, real-world context.
                </p>
              </div>
            </div>
            <div
              class="contentMiniClass"
              id="equivalancyValues"
              *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0"
            >
              <p class="content-name-subtitle uniqTableSeq">
                Table #1: Equivalence values - per package
              </p>
              <div>
                <piqet-angular-organiaztion-equivalancy-unit
                  [spiderChartItemsData]="spiderChartItemsData"
                  [isISOReport]="true"
                ></piqet-angular-organiaztion-equivalancy-unit>
              </div>
            </div>
            <div
              class="contentMiniClass"
              *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0"
            >
              <p class="content-name-subtitle uniqTableSeq">
                Table #1: Life cycle impacts relative to reference scenario - Per package
              </p>
              <div class="row">
                <div class="col12">
                  <p class="content-page-details">{{ reportResource.lblLowerImpact }}</p>
                  <p class="content-page-details">{{ reportResource.lblHigherImpact }}</p>
                </div>
              </div>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>{{ reportResource.lblCategory }}</td>
                      <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
                        {{ item?.scenarioname }}
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      *ngFor="
                        let p of getRange(
                          spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';')
                            ?.length
                        )
                      "
                    >
                      <td>
                        <span style="padding-right: 15px">{{ indicatornamelist[p] }}</span>
                        <span class="verticalTableHeader" style="margin-top: 1px !important"
                          >({{ indicatorunitnamelist[p] }})</span
                        >
                      </td>
                      <td *ngFor="let data of spiderChartItemsData.scenarioListForAnnumImpact">
                        {{ data.savingPercentage.split(';')[p] | decimalFormatPipe }}%
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="contentMiniClass"
              *ngIf="spiderChartItemsData?.scenarioListForAnnumImpact?.length > 0"
            >
              <p class="content-name-subtitle uniqTableSeq">
                Table #1: Life cycle impacts relative to reference scenario - Per annum
              </p>
              <!-- this div not is piqet 4  -->
              <div class="row">
                <div class="col12">
                  <p class="content-page-details">{{ reportResource.lblLowerImpact }}</p>
                  <p class="content-page-details">{{ reportResource.lblHigherImpact }}</p>
                </div>
              </div>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td>{{ reportResource.lblCategory }}</td>
                      <td *ngFor="let item of spiderChartItemsData.scenarioListForAnnumImpact">
                        {{ item?.scenarioname }}
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      *ngFor="
                        let p of getRange(
                          spiderChartItemsData?.scenarioListForAnnumImpact[0]?.indicators.split(';')
                            ?.length
                        )
                      "
                    >
                      <td>
                        <span style="padding-right: 15px">{{ indicatornamelist[p] }}</span>
                        <span class="verticalTableHeader" style="margin-top: 1px !important"
                          >({{ indicatorunitnamelist[p] }})</span
                        >
                      </td>
                      <td *ngFor="let data of spiderChartItemsData.scenarioListForAnnumImpact">
                        {{ data.savingPercentage.split(';')[p] | decimalFormatPipe }} %
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </div>
        <div
          class="row space contentClass"
          id="interpretation"
          [ngClass]="{ parentTitle: interpretationFlag }"
          *ngIf="interpretationFlag"
        >
          <div class="headingTitle parentNumber">#1Parent. Interpretation</div>
          <div
            class="contentMiniClass"
            id="contributionAnalysis"
            *ngIf="
              reportAccessData &&
              (reportAccessData.interpretation
                | sectionFilter
                  : reportInterpretation.contributionalAnalysis) as contributionalAnalysis
            "
          >
            <p class="content-name childNumber">#1Child Contribution analysis</p>
            <div class="content-text contentMiniClass">
              <p>
                First, a contribution analysis is provided to identify the hotspots in each of the
                options.
              </p>
              <p>
                This section shows in detail the impacts for each scenario by life cycle stage for
                each of the selected environmental indicators based on the chosen functional unit.
              </p>
              <p>
                <a (click)="scrollToElement(climatemateImpactFigureId - 1 + 'figureIndex')"
                  >Figure {{ climatemateImpactFigureId }}</a
                >
                Climate change (kg CO<sub>2</sub> -e) impacts by life cycle stage.
              </p>
            </div>
          </div>
          <div
            class="commonMargin"
            *ngIf="
              reportAccessData &&
              (reportAccessData.interpretation
                | sectionFilter
                  : reportInterpretation.contributionalAnalysisByStage) as contributionalAnalysisByStage
            "
            id="contributionAnalysisByStage"
          >
            <p class="content-name childNumber">
              #1Child Contribution analysis by life cycle stage
            </p>
            <div
              *ngFor="
                let indicatorDetail of reportData.interpretation
                  .lifeCycleStageContributionImpactItems;
                let i = index
              "
            >
              <p class="content-name">
                <span class="Titalcase"> {{ indicatorDetail.indicatorName }}</span
                >&nbsp; ({{ indicatorDetail.indicatorUnitName }})
              </p>
              <p class="content-name-subtitle uniqTableSeq">
                Table #1: {{ indicatorDetail.indicatorName }}
                {{ reportResource.lblLifeCycle | lowercase }} -
                {{ reportData?.common?.functionalUnitName | lowercase }}
              </p>

              <piqet-angular-life-cycle-stage-chart
                [indicatorDetail]="indicatorDetail.impactItems"
                [isIsoReport]="true"
              ></piqet-angular-life-cycle-stage-chart>
              <p class="content-figure uniqFigureSeq">
                Figure #1: {{ indicatorDetail.indicatorName }} ({{
                  indicatorDetail?.indicatorUnitName
                }}) comparison {{ reportResource.lblLifeCycle | lowercase }} -
                {{ reportData?.common?.functionalUnitName | lowercase }}
              </p>
            </div>
          </div>
          <div
            class="commonMargin"
            *ngIf="
              reportAccessData &&
              (reportAccessData.interpretation
                | sectionFilter
                  : reportInterpretation.contributionalAnalysisByComponent) as contributionalAnalysisByComponent
            "
            id="contributionAnalysisByComponent"
          >
            <p class="content-name childNumber">#1Child Contribution analysis by component</p>
            <div
              *ngFor="
                let indicatorDetailForComponent of reportData.interpretation
                  ?.componentContributionItems;
                let i = index
              "
            >
              <p class="content-name">
                <span class="Titalcase">{{ indicatorDetailForComponent.indicatorName }}</span
                >&nbsp; ({{ indicatorDetailForComponent.indicatorUnitName }})
              </p>
              <p class="content-name-subtitle uniqTableSeq">
                Table #1: {{ indicatorDetailForComponent.indicatorName }}
                {{ reportResource.lblPackagingComponents | lowercase }}
                -
                {{ reportData?.common?.functionalUnitName | lowercase }}
              </p>

              <piqet-angular-report-bar-chart-component
                [isIsoReport]="true"
                [impactItems]="indicatorDetailForComponent.impactItems"
                [unitName]="indicatorDetailForComponent.indicatorName"
              ></piqet-angular-report-bar-chart-component>
              <p class="content-figure uniqFigureSeq">
                Figure #1: {{ indicatorDetailForComponent.indicatorName }} ({{
                  indicatorDetailForComponent?.indicatorUnitName
                }}) comparison
                {{ reportResource.lblPackagingComponents | lowercase }}
                -
                {{ reportData?.common?.functionalUnitName | lowercase }}
              </p>
            </div>
          </div>
          <div
            class="commonMargin"
            *ngIf="
              reportAccessData &&
              (reportAccessData.interpretation
                | sectionFilter
                  : reportInterpretation.contributionalAnalysisByPackaging) as contributionalAnalysisByPackaging
            "
            id="contributionAnalysisByPackaging"
          >
            <p class="content-name childNumber">#1Child Contribution analysis by packaging level</p>
            <div
              *ngFor="
                let indicatorDetailForPackaging of reportData.interpretation
                  ?.packagingLevelContributionImpactItems;
                let i = index
              "
            >
              <p class="content-name">
                <span class="Titalcase">{{ indicatorDetailForPackaging.indicatorName }}</span
                >&nbsp; ({{ indicatorDetailForPackaging.indicatorUnitName }})
              </p>
              <p class="content-name-subtitle uniqTableSeq">
                Table #1: {{ indicatorDetailForPackaging.indicatorName }} {{ reportResource.lblPackingLevelStage | lowercase }} -
                {{ reportData?.common?.functionalUnitName | lowercase }}
              </p>

              <piqet-angular-report-bar-chart
                [impactItems]="indicatorDetailForPackaging.impactItems"
                [isIsoReport]="true"
              ></piqet-angular-report-bar-chart>
              <p class="content-figure uniqFigureSeq">
                Figure #1: {{ indicatorDetailForPackaging.indicatorName }} ({{
                  indicatorDetailForPackaging?.indicatorUnitName
                }}) comparison
                {{ reportResource.lblPackingLevelStage | lowercase }}
                -
                {{ reportData?.common?.functionalUnitName | lowercase }}
              </p>
            </div>
          </div>
          <div>
            <div
              class="commonMargin"
              *ngFor="
                let item of reportData.interpretation.scenarioContributionItems;
                let k = index
              "
            >
              <p class="content-name">{{ reportResource.lblResultScenario }}</p>
              <p class="content-sub-name">
                <span class="Titalcase"> {{ item.scenarioName }} contribution analysis</span>
              </p>

              <piqet-angular-report-detail-contribution-chart
                [impactItems]="item.impactItems"
                [scenarioName]="item?.scenarioName"
                [index]="k"
              ></piqet-angular-report-detail-contribution-chart>
              <div class="contentClass">
                <p class="content-figure uniqFigureSeq">
                  Figure #1: {{ reportResource.lblAllLifeCycle }} - {{ item.scenarioName }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="contentMiniClass"
            id="sensitivityAnalysis"
            *ngIf="
              reportAccessData &&
              (reportAccessData.interpretation
                | sectionFilter
                  : reportInterpretation.sensitivityAssessment) as sensitivityAssessment
            "
          >
            <p class="content-name childNumber">#1Child Sensitivity analysis</p>
            <ng-container *ngIf="sensitivityAnalysis?.length > 0; else noDataSensitivity">
              <div class="content-text">
                <ng-container
                  *ngIf="
                    reportData?.goalAndScope?.sensitivityAnalysisDescription?.trim();
                    else defaultSensitivityText
                  "
                >
                  {{ reportData?.goalAndScope.sensitivityAnalysisDescription }} The following
                  sensitivity analyses were conducted:
                </ng-container>

                <ng-template #defaultSensitivityText>
                  Several scenarios were considered to shed light on how variations in input data
                  could affect the study results. The following sensitivity analyses were conducted:
                </ng-template>
              </div>
              <div *ngFor="let item of sensitivityAnalysis">
                <div class="contentMiniClass">
                  <p class="content-name-subtitle uniqTableSeq">
                    Table #1: Summary of sensitivity analysis
                  </p>
                  <div class="table-content my-2">
                    <table class="table">
                      <thead>
                        <tr>
                          <td>Variants</td>
                          <td>Short name</td>
                          <td>Long name</td>
                          <td>Scenario comment</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Reference</td>
                          <td>{{ item.variationDetail.shortName }}</td>
                          <td>{{ item.variationDetail.name }}</td>
                          <td>
                            {{
                              item.variationDetail.description == ''
                                ? '–'
                                : item.variationDetail.description
                            }}
                          </td>
                        </tr>
                        <ng-container
                          *ngFor="let childItem of item.variationDetail.childItems; let i = index"
                        >
                          <tr *ngIf="childItem.shortName && childItem.name">
                            <td>Variation {{ i + 1 }}</td>
                            <td>{{ childItem.shortName }}</td>
                            <td>{{ childItem.name }}</td>
                            <td>{{ childItem.description == '' ? '–' : childItem.description }}</td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="contentMiniClass">
                  <p class="content-name-subtitle uniqTableSeq">
                    Table #1: Sensitivity analysis results
                  </p>
                  <div class="table-content my-2">
                    <!-- <p class="content-text text-danger">DOne</p> -->
                    <table class="table">
                      <thead>
                        <tr>
                          <td></td>
                          <td
                            class="sensitivityAnalysis"
                            *ngFor="let childItem of item.variationDetail.childItems"
                          >
                            <ng-container *ngIf="childItem.name != '' && childItem.shortName"
                              >{{ childItem.name }} variation from
                              {{ item.variationDetail.name }}</ng-container
                            >
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let totalImpactItems of item.sensitivityAnalysis; let i = index"
                        >
                          <td style="width: 30%">
                            {{ totalImpactItems.indicatorName }}
                            {{ totalImpactItems.indicatorUnitName }}
                          </td>
                          <ng-container
                            *ngFor="
                              let totalImpactItem of totalImpactItems.totalImpactValues.split(';');
                              let j = index
                            "
                          >
                            <td
                              *ngIf="
                                j < item.variationDetail.childItems?.length &&
                                item.variationDetail.childItems[j].name != ''
                              "
                            >
                              <span style="color: black">{{ totalImpactItem }}</span>
                            </td>
                          </ng-container>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="content-text">
                  These specific scenarios were designed to investigate the more uncertain and
                  biggest contributor to the {{ reportData?.common?.baseScenarioName }}
                  environmental impacts.
                </div>
              </div>
            </ng-container>

            <ng-template #noDataSensitivity>
              <div class="content-text">
                {{ commonData?.organizationName }} did not include a sensitivity analysis in this
                assessment.
              </div>
            </ng-template>
          </div>
          <div
            class="contentMiniClass"
            id="pInterpretation"
            *ngIf="
              reportAccessData &&
              (reportAccessData.interpretation
                | sectionFilter
                  : reportInterpretation.interpretationSummary) as interpretationSummary
            "
          >
            <p class="content-name childNumber">#1Child Interpretation</p>
            <div class="content-text">
              The interpretation step examines the results through a series of analyses and checks
              to better understand the results of the LCA, and to ensure any conclusions drawn from
              the LCA are robust and well supported by the data.
              <br />
              <br />
              <span
                class="common-font"
                [innerHTML]="formatText(reportData?.interpretation?.interpretation)"
              ></span>
            </div>
          </div>
          <ng-container
            *ngIf="
              reportAccessData &&
              (reportAccessData.interpretation
                | sectionFilter
                  : reportInterpretation.dataQualityAssessment) as dataQualityAssessment
            "
          >
            <div class="contentMiniClass" id="dataQualityAssessment5">
              <p class="content-name childNumber">#1Child Data quality assessment</p>
              <div class="content-text">
                <a (click)="scrollToElement(qualityTableId - 1 + 'tableIndex')"
                  >Table {{ qualityTableId }}</a
                >
                shows a qualitative data quality assessment for major inputs to the LCA.
              </div>
            </div>
            <div class="contentMiniClass">
              <p class="content-name-subtitle customTableDataquality uniqTableSeq">
                Table #1: Data quality assessment
              </p>
              <div class="table-content">
                <table class="table">
                  <thead>
                    <tr>
                      <td style="width: 30%">Process</td>
                      <td style="width: 12%">Data</td>
                      <td style="width: 23%">Geography</td>
                      <td style="width: 12%">Temporal</td>
                      <td style="width: 23%">Technology</td>
                    </tr>
                  </thead>
                  <tbody
                    *ngIf="
                      dataQualityAssessmentList?.dataQualityAssessmentData?.length > 0;
                      else noData
                    "
                  >
                    <ng-container
                      *ngFor="let item of dataQualityAssessmentList?.dataQualityAssessmentData"
                    >
                      <tr class="rowBottomTransparent">
                        <td>
                          <div class="section">
                            <div>
                              {{ !!item.process && item.process != '' ? item.process : '–' }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="section">
                            <div>{{ item.source }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="section">
                            <div class="DQA-container">
                              <div class="DQA-label">{{ item.geography }}</div>
                            </div>
                          </div>
                        </td>

                        <td>
                          <div class="section">
                            <div class="DQA-container">
                              <div class="DQA-label">{{ item.timePeriod }}</div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <div class="section">
                              <div class="DQA-container">
                                <div class="DQA-label">
                                  {{ item.technologyName == '' ? '–' : item.technologyName }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr class="rowBottomTransparent">
                        <td></td>
                        <td></td>
                        <td>
                          <div class="section">
                            {{ item.geographyComment ? 'Comment: ' : ''
                            }}{{ item.geographyComment }}
                          </div>
                        </td>
                        <td>
                          <div class="section">
                            <div class="comment">
                              {{ item.temporalComment ? 'Comment: ' : ''
                              }}{{ item.temporalComment }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="section">
                            <div class="comment">
                              {{ item.technologyComment ? 'Comment: ' : ''
                              }}{{ item.technologyComment }}
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>
                          <div class="section">
                            <div
                              *ngIf="
                                !!item.geography && item.geography != '' && item.geography != '-'
                              "
                              class="rating-icons-container timePeriodCellICON"
                            >
                              <i
                                *ngFor="let rating of ratings"
                                [id]="'dataAssesmentQuality3-' + rating.value"
                                class="pointer-event fa"
                                [ngClass]="
                                  item?.geographyRating == rating.value
                                    ? 'fa-circle'
                                    : 'fa-circle-thin'
                                "
                                [title]="rating.title"
                                [style.color]="rating.color"
                              ></i>
                            </div>
                          </div>
                        </td>

                        <td>
                          <div class="section">
                            <div
                              *ngIf="
                                !!item.timePeriod && item.timePeriod != '' && item.timePeriod != '-'
                              "
                              class="rating-icons-container timePeriodCellICON"
                            >
                              <i
                                *ngFor="let rating of ratings"
                                [id]="'dataAssesmentQuality3-' + rating.value"
                                class="pointer-event fa"
                                [ngClass]="
                                  item?.temporalRating == rating.value
                                    ? 'fa-circle'
                                    : 'fa-circle-thin'
                                "
                                [title]="rating.title"
                                [style.color]="rating.color"
                                style="cursor: default"
                              ></i>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="section">
                            <div
                              *ngIf="
                                !!item.technologyName &&
                                item.technologyName != '' &&
                                item.technologyName != '-'
                              "
                              class="rating-icons-container timePeriodCellICON"
                            >
                              <i
                                *ngFor="let rating of ratings"
                                [id]="'dataAssesmentQuality3-' + rating.value"
                                class="pointer-event fa"
                                [ngClass]="
                                  item?.technoRating == rating.value
                                    ? 'fa-circle'
                                    : 'fa-circle-thin'
                                "
                                [title]="rating.title"
                                [style.color]="rating.color"
                              ></i>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                  <ng-template #noData>
                    <tbody>
                      <tr class="text-center">
                        <td colspan="5">No record is available</td>
                      </tr>
                    </tbody>
                  </ng-template>
                </table>
              </div>
            </div>
            <div class="contentMiniClass">
              <p class="content-name">Key</p>
              <ul class="reviewUL">
                <li *ngFor="let item of reviewColorList; let i = index" style="list-style: none">
                  <span class="circle" [style.background-color]="item.color"></span>
                  <span class="text">{{ item?.description }}</span>
                </li>
              </ul>
            </div>
          </ng-container>
          <div
            class="contentMiniClass"
            id="pInterpretation"
            *ngIf="
              reportAccessData &&
              (reportAccessData.interpretation
                | sectionFilter
                  : reportInterpretation.interpretationSummary) as interpretationSummary
            "
          >
            <p class="content-name childNumber">#1Child Interpretation</p>
            <div class="content-text">
              The interpretation step examines the results through a series of analyses and checks
              to better understand the results of the LCA, and to ensure any conclusions drawn from
              the LCA are robust and well supported by the data.
              <br />
              <br />
              <span
                class="common-font"
                [innerHTML]="formatText(reportData?.interpretation?.interpretation)"
              ></span>
            </div>
          </div>
        </div>
        <div
          class="row space contentClass"
          id="conclusion"
          [ngClass]="{ parentTitle: conclusionFlag }"
          *ngIf="conclusionFlag"
        >
          <div class="headingTitle parentNumber">#1Parent. Conclusion</div>
          <div
            class="contentMiniClass"
            id="limitationOfTheStudy"
            *ngIf="
              reportAccessData &&
              (reportAccessData.conclusion
                | sectionFilter : reportConclusion.limitationOfStudy) as limitationOfStudy
            "
          >
            <p class="content-name childNumber">#1Child Limitations of the study</p>
            <div class="content-text contentMiniClass">
              <p>
                While PIQET serves as a valuable tool for understanding environmental impacts, it
                inherently carries certain limitations. It's crucial to acknowledge that PIQET
                operates within the confines of a model, reliant on assumptions and approximations
                made to depict the life cycle of the packaging process.
              </p>
              <p>
                These assumptions, though necessary, introduce a level of uncertainty into the
                assessment.
              </p>
              <p>
                Firstly, the material data selection has limitations related to data diversity, time
                frame variations, and potential inconsistencies. The default converting data relies
                on assumed industry norms. The sensitivity analysis/es help mitigate these
                assumptions, emphasizing the need to consider these factors when interpreting
                results in the context of ISO-14044 compliance.
              </p>
            </div>
          </div>
          <div
            class="contentMiniClass"
            id="recommendationsAndConclusions"
            *ngIf="
              reportAccessData &&
              (reportAccessData.conclusion
                | sectionFilter : reportConclusion.recommendations) as recommendations
            "
          >
            <p class="content-name childNumber">#1Child Recommendations and conclusions</p>
            <div
              *ngIf="
                !!commonData?.recommendationsAndConclusions &&
                  commonData?.recommendationsAndConclusions != '';
                else recommendationsAndConclusions
              "
              class="content-text contentMiniClass"
            >
              <p>{{ commonData?.recommendationsAndConclusions }}</p>
            </div>
            <ng-template #recommendationsAndConclusions>
              <div>
                <p>{{ reportResource.lblNoTextAdded }}</p>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
